export default theme => {
    return {}
}



// WEBPACK FOOTER //
// ./src/app/configuration/Demo/AutoDashboard/theme/components/scorecard/MetricsLabels/index.js